import { Injectable } from '@angular/core';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { SelectServiceData } from './../data-services/select-service-data.service';
import { ServiceFilterModel } from '../business-entities/service-filter-model';

@Injectable({providedIn: 'root'})
export class SelectService {
    constructor(private ssDataService: SelectServiceData) {}

    GetSelectServiceSectionDetails(serviceFilterModel:ServiceFilterModel): Promise<GenericResponse<any>> {
        return this.ssDataService.GetSelectServiceSectionDetails(serviceFilterModel);
    }

    async getWarningLightDropDown(language: string) {
        let warninglightList: any;
        await this.ssDataService
            .getWarningLightDropDown(language)
            .then(
                (res: GenericResponse<any>) => {
                    warninglightList = res.responseObject;
                }
            );

        return warninglightList;
    }
}